import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@vs-shop/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';

import { BANNER_LISTING_DELAY_MILLIS } from '../../../config/banner';

import Banner from './Banner';

import type { Banner as BannerT } from '../../../effect/schema/openapi/backend';
import { BannerVariant } from '@vs-shop/commerce-ui/banner';

type Props = {
  banners: readonly BannerT[];
};

export default function ProductListingBannerCarousel({ banners }: Props) {
  const [first] = banners;
  if (banners.length === 1) {
    if (first === undefined) return null;
    return <Banner banner={first} variant={BannerVariant.PRODUCT_CARD} />;
  }

  return (
    <Carousel
      plugins={[Autoplay({ delay: BANNER_LISTING_DELAY_MILLIS })]}
      opts={{ loop: true }}
      className="overflow-hidden"
    >
      <CarouselContent className="-ml-0">
        {banners.map((banner) => {
          return (
            <CarouselItem key={banner.id} className="pl-0">
              <Banner banner={banner} variant={BannerVariant.PRODUCT_CARD} />
            </CarouselItem>
          );
        })}
      </CarouselContent>

      <CarouselPrevious navSize="overlay" />
      <CarouselNext navSize="overlay" />
    </Carousel>
  );
}
